// extracted by css-extract-rspack-plugin
export default {"select_dealer_wrap":"zxxEjnVJde4_67Ti","deaelers_container":"EgOLBHy75SgPby6A","dealer_name":"MIMG6qjebbkftk51","dealer_form_select":"KGy0lfayAP4ZXNxR"};